import React from "react";
import Skeleton from "../../tasks/elementalUI/skeleton/Skeleton";

const CardSectionSkeleton = () => {
  return (
    <div className="card-section-skeleton">
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </div>
  );
};

export default CardSectionSkeleton;
